module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Settings-6ca81991de8301deaf80ae20ca3f37cd.svg";